<template>
	<div v-if="!hideForCountry" class="quick-start-protocol">
		<div class="title-info">
			<a
				@click="trackDetailURLClick"
				class="title-link"
				:href="currentProtocol.detail_URL"
				target="_blank"
				rel="noopener"
			>
				<h6 class="title">{{ currentProtocol.title }}</h6>
			</a>

			<div class="language-info-download">
				<div class="language">
					<dropdown-custom
						:placeholder="'Language'"
						:list-options="dropdownItems"
						:value="selectedLanguage"
						@input="setLanguage"
					/>
				</div>
				<div class="info">{{ fileInfo }}</div>
				<div class="download">
					<a @click="trackDownloadProtocolClick" :href="currentProtocol.download_URL">
						<base-icon icon-name="download" />
					</a>
				</div>
			</div>
		</div>

		<div class="description">
			<p v-html="currentProtocol.description" class="description" />
		</div>
	</div>
</template>

<script>
import DropdownCustom from '@/components/dropdown-custom/DropdownCustom';
import {createLanguageOption} from '@/util/createLanguageOption.js';
import {trackEvent} from '@/services/tracking.js';

export default {
	name: 'QuickStartProtocol',
	components: {DropdownCustom},
	props: {
		protocol: {
			type: Object,
		},
	},

	data() {
		return {
			selectedLanguage: null,
			languagesList: [],
		};
	},

	created() {
		this.languagesList = Object.keys(this.protocol.language_versions);
		if (this.languagesList.includes('en')) {
			this.selectedLanguage = createLanguageOption('en', this.LANG);
		} else {
			this.selectedLanguage = createLanguageOption(this.languagesList[0], this.LANG);
		}
	},

	computed: {
		LANG() {
			return this.$store.state.LANG;
		},
		fileInfo() {
			return `${this.currentProtocol.file_format.toUpperCase()} (${this.currentProtocol.file_size})`;
		},

		country() {
			return this.$store.state.COUNTRY;
		},

		hideForCountry() {
			return this.protocol.hide_countries.includes(this.country);
		},

		currentProtocol() {
			return this.protocol.language_versions[this.selectedLanguage.key];
		},
		dropdownItems() {
			return this.languagesList.map((language) => createLanguageOption(language, this.LANG));
		},
	},

	methods: {
		createLanguageOption(language) {
			return {
				key: language,
				children: [],
				value: {
					[this.LANG]: language.toUpperCase(),
				},
				disabled: false,
			};
		},

		trackDetailURLClick() {
			trackEvent('ctaClick', {eVar58: 'Open QSP link| Workflow Configurator'});
		},

		trackDownloadProtocolClick() {
			trackEvent('ctaClick', {eVar58: 'Download QSP| Workflow Configurator'});
		},

		setLanguage(value) {
			this.selectedLanguage = value;
		},
	},
};
</script>

<style lang="scss" scoped>
.quick-start-protocol {
	min-height: 76px;
	display: flex;
	flex-direction: column;
	margin: 0px 0px 0px 0px;
	padding: 10px 16px;
	border-top: 1px solid $color-mid-grey;

	&:first-child {
		margin-top: 26px;
	}

	&:last-child {
		border-bottom: 1px solid $color-mid-grey;
	}

	.title-info {
		margin-top: 5px;
		display: flex;
		justify-content: space-between;

		@media (max-width: $mobile) {
			flex-direction: column;
		}

		.title-link {
			display: flex;
			align-items: center;

			&:hover {
				text-decoration: none;
			}
		}

		.title {
			height: fit-content;
			padding: 0;
			margin: 0;
			font-family: Futura W01;
			font-size: 16px;
			font-style: normal;
			font-weight: 500;
			line-height: 23px;
			letter-spacing: 0.4px;
			text-align: left;
			color: $color-blue;

			@media (max-width: $tablet) {
				font-size: 14px;
			}
		}
	}

	.language-info-download {
		font-family: Futura PT;
		font-size: 13px;
		font-style: normal;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.4px;
		text-align: left;
		color: $color-grey;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;

		@media (max-width: $mobile) {
			justify-content: left;
			align-items: flex-end;
		}

		.info,
		.download,
		.language {
			height: 50px;
			display: flex;
		}

		.language {
			align-items: flex-start;
			min-width: 110px;
			margin-right: 16px;

			> div {
				width: 110px;
			}
		}

		.info {
			align-items: center;
			font-family: Futura W01 Book;
			font-size: 13px;
			font-style: normal;
			font-weight: 400;
			line-height: 20px;
			letter-spacing: 0.4px;
			text-align: left;
			margin-right: 20px;

			@media (max-width: $tablet) {
				font-size: 11px;
			}
		}

		.download {
			align-items: center;
			margin-right: 0;
		}
	}

	.description {
		margin-top: 5px;
		font-family: Futura W01 Book;
		font-size: 18px;
		font-style: normal;
		font-weight: 400;
		line-height: 28px;
		letter-spacing: 0.5px;
		text-align: left;
		color: $color-text-grey;

		@media (max-width: $tablet) {
			font-size: 16px;
		}
	}
}
</style>
